export default __webpack_public_path__ + "static/media/grafema_tour-guide-cale-do-oiro_01.f81d6b69.jpg";